// This allows us to redirect to a URL that is not on the same host as the current page and avoid CORS issues.
Turbo.StreamActions.redirect_to = function () {
  window.location.assign(this.dataset.url)
}
